import data from './data.json'
import st from './RussiaMap.module.scss'
import {useRegions, useScreenSize} from 'helpers';
import {Tooltip} from './Tooltip';
import {SelectField} from 'components/SelectField/SelectField';
import {useAppContext} from '../../Context';

const Path = ({id, regionName, path, polygonRef, isActive, onRegionClick, isOn}) => {

    return (
        <path
            className={[st.map_path, isActive ? st.isActive : '', isOn ? st.isOn : ''].join(' ')}
            ref={ isActive ? polygonRef : null }
            data-code={id}
            data-region={regionName}
            d={path}
            onClick={onRegionClick}
        />
    )
}



export const RussiaMap = () => {
    const { dataList } = useRegions()
    const { mapOptions: { polygonRef, popupRef, select, setSelect, regionName }, regions } = useAppContext()
    const { isMobile, isTablet } = useScreenSize()

    const onRegionClick = (id) => ()=> {
        setSelect(regions?.data?.data?.find(item => item.code === id))
    }
    const isOn = (code)=> {
        return dataList?.data?.data?.find(item => item.code === code)?.active
    }
    return (
        <div className="wrapper">
            <div className={st.mapBlock}>
                {!isMobile &&
                    <div className={st.mapSelect}>
                        {isTablet ? <SelectField setRegion={setSelect} activeItem={select?.id}/> :
                            <SelectField setRegion={setSelect} activeItem={select?.id} menuIsOpen />
                        }
                    </div>
                }

                <div className={st.map} id="russian-map">
                    {select?.id !== 0 && !!select && <Tooltip popupRef={popupRef} region={regionName} setSelect={setSelect}  />}

                    <svg
                        className={st.scheme}
                        viewBox="0 0 1954 1155"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <g className={st.path_group}>
                            {data && data.map((scheme, index) => {
                                if (scheme?.group) {
                                    return (
                                        <g
                                            key={index+'-'+scheme.id}
                                            data-type="path-group"
                                            className={`${st.map_path_group} ${select === scheme.id ? st.pathGroupActive : ''}`}
                                        >
                                            {scheme.group.map((g, i)=> (
                                                <Path
                                                    key={i+'-'+scheme.id}
                                                    path={g}
                                                    id={scheme.code}
                                                    polygonRef={i === 0 ? polygonRef : null}
                                                    isMain={i===0}
                                                    regionName={scheme.name}
                                                    isActive={select?.code === scheme.code}
                                                    onRegionClick={isOn(scheme.code) ? onRegionClick(scheme.code) : null}
                                                    isOn={isOn(scheme.code)}
                                                />))}
                                        </g>
                                    )
                                }

                                return <Path
                                    key={index+'-'+scheme.id}
                                    path={scheme.path}
                                    id={scheme.code}
                                    polygonRef={polygonRef}
                                    regionName={scheme.name}
                                    isActive={select?.code === scheme.code}
                                    onRegionClick={isOn(scheme.code) ? onRegionClick(scheme.code) : null}
                                    isOn={isOn(scheme.code)}
                                />
                            })}
                        </g>
                    </svg>
                </div>
            </div>

            {isMobile &&
                <div className={st.mapSelect}>
                    <SelectField setRegion={setSelect} activeItem={select?.id}/>
                </div>
            }
        </div>
    )
}
